<!--  FINANCE APPLY  -->

<div class="written-content padded">
	<h3>Apply for finance with our finance partner...</h3>
	<p>
		To apply for finance you will be sent to our finance partner's application page. Once completed you will be returned to complete your customised deal. Do you wish to continue?
	</p>
</div>

<!--  END FINANCE APPLY  -->
